import { TitleBar } from "./Model";
import React, { useState, useMemo } from "react";
import { Form } from "antd";
import { isEmpty } from "../utils";
import { useUtils } from "../hooks";
import { useSelector } from "react-redux";

const MatriRadio = ({ info, onChange, value = [] }) => {
  const { isSame } = useUtils();
  const { isMobile } = useSelector((state) => state.app);
  const [scroll, setScroll] = useState(false);
  const { col, row } = useMemo(
    () => ({ col: info.answerList || [], row: info.matrixRowList || [] }),
    [info]
  );
  const handleClick = (rowItem, colItem) => {
    let _value = [...value];
    let index = _value.findIndex((o) =>
      isSame(o.rowPosition, rowItem.position)
    );
    if (index >= 0) {
      _value.splice(index, 1);
    }
    _value.push({
      matrixId: rowItem.id,
      rowPosition: rowItem.position,
      answerId: colItem.id,
      colPosition: colItem.position,
    });
    onChange(_value);
  };

  const wrapProps = {
    className: `table-wrap ${!isMobile && scroll ? "scroll" : ""}`,
    onScroll: isMobile ? null : (e) => setScroll(e.target.scrollLeft != 0),
  };
  const noSingle = row.length != 1;
  const widths = useMemo(() => {
    const pcFirstColWidth = 210;
    let colWidth = "auto";
    let tableWidth = "100%";
    if (isMobile && col.length > 11) {
      colWidth = 36;
      tableWidth = colWidth * col.length;
    } else if (!isMobile && col.length > 13) {
      tableWidth = pcFirstColWidth + 65 * col.length;
    }
    return { tableWidth, colWidth, pcFirstColWidth };
  }, [isMobile, col]);
  return (
    <div {...wrapProps}>
      <table
        className={`matrix-table matrix-radio ${noSingle ? "" : "single"}`}
        style={{ width: widths.tableWidth }}
      >
        <tbody>
          <tr className="head">
            {!isMobile && noSingle && (
              <th className="first-item" width={widths.pcFirstColWidth}></th>
            )}
            {col.map((item, i) => (
              <th key={i} style={{ width: widths.colWidth }}>
                <span className="text">{item.label || item.text}</span>
              </th>
            ))}
          </tr>
          {row.map((rowItem, i) => {
            let isError = false;
            if (info?.errorMsg?.positions) {
              isError = info?.errorMsg?.positions.find((o) =>
                isSame(o, rowItem.position)
              );
              isError = !isEmpty(isError);
            }
            return (
              <React.Fragment key={i}>
                {isMobile && noSingle && (
                  <tr className="row-title">
                    <td
                      className={`row-title-item ${isError ? "error" : ""}`}
                      colSpan={col.length}
                    >
                      <span>{rowItem.text}</span>
                    </td>
                  </tr>
                )}
                <tr>
                  {!isMobile && noSingle && (
                    <td className={`first-item  ${isError ? "error" : ""}`}>
                      <span>{rowItem.label || rowItem.text}</span>
                    </td>
                  )}
                  {col.map((colItem, i) => {
                    let isCheck = false;
                    let valueItem = value.find((o) =>
                      isSame(o?.rowPosition, rowItem.position)
                    );
                    if (valueItem) {
                      isCheck = isSame(valueItem.colPosition, colItem.position);
                    }
                    return (
                      <td key={i} onClick={() => handleClick(rowItem, colItem)}>
                        <div className="icon-wrap">
                          <div
                            className={`icon radio ${isCheck ? "check" : ""}`}
                          ></div>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const MatrixRadioViews = (props) => {
  const { info } = props;
  return (
    <div className="components-matrix-radio-views">
      <TitleBar info={info}></TitleBar>
      <Form.Item noStyle name={["postAnswer", info.position]}>
        <MatriRadio info={info} />
      </Form.Item>
    </div>
  );
};

export default MatrixRadioViews;
